import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import { ModalReducerState, ModalReducerStateIdKeys } from "./reducer_interface";

const CustomerProfileModals = {
  CUSTOMER_PROFILE_APPOINTMENTS_TABLE_COMMENTS_VIEW_MORE: false,
  CUSTOMER_PROFILE_MISSING_INFORMATION: false,
  APPOINTMENTS_BOOK_AGAIN: false,
  NO_APP_SEND_REQUEST: false,
  APPOINTMENT_CANCELATION: false,
  APPOINTMENT_RESCHEDULE: false,
  APPOINTMENT_RESCHEDULE_SHIFT: false,
  APPOINTMENT_REFUND: false,
  PWL_APPOINTMENT_ACTION: false,
  LOGOUT: false,
  ADD_ADDRESS_MODAL: false,
  NEW_SERVICE_MODAL: false,
  CUSTOMER_PET_MISSING_DETAILS: false,
  BOOKED_SLOTS_DETAILS: false,
  CLINIC_ONBOARD_CAPACITY: false,
  IMAGE_CATEGORY_MODAL: false,
  COPY_IMAGE_MODAL: false,
  MEMBERSHIP_USAGE_MODAL: false,
  PURCHASE_ORDER_REQUEST: false,
  NO_INTERNET_MODAL: false,
  BOOKING_MISSING_DETAILS_EDIT_MODAL: false,
  SELECT_CITY_AND_CLINIC_MODAL: false,
  EMR_OVERDRAFT_MODAL: false,
  EMR_QUICK_VIEW_MODAL: false,
  APP_VERSION_CHANGE_MODAL: false,
  EMR_VERIFY_PET_WEIGHT: false,
  INVENTORY_ONBOARD: false,
  ASK_AI_MODAL: false,
  EMR_SUBMISSION_MODAL: false,
  CALENDAR_BLOCK_DETAILS_MODAL: false,
  INVENTORY_SERVICE_CONFIGURE_CITY_MODAL: false,
  PRODUCT_CATALOGUE_ONBOARD_IMAGES_MODAL: false,
  CUSTOMER_PROFILE_APPOINTMENTS_TABLE_COMMENTS_EDIT: false,
  BOOKINGS_PAYMENT_STATUS: false,
  SPEECH_RECOGNITION_MODAL: false,
  BULK_UPLOAD_MODAL: false,
  CREATE_PO_FROM_SHEET_MODAL: false,
  GOOD_TO_BAD_MODAL: false,
  BAD_INVENTORY_VIEW_IMAGE: false,
  PO_RAISE_ERROR_MODAL: false,
  PO_STATUS_UPDATE: false,
  GRN_STATUS_UPDATE: false,
  IS_OVERBOOKING_ALLOWED_MODAL: false,
  BOOKING_COMMENTS_MODAL: false,
  UI_THEME_CHANGE_MODAL: false,
  CART_ITEM_ADD_MODAL: false,
  CART_STOCK_INCOMPLETE_MODAL: false,
  CART_REMOVE_ITEM: false,
  LOGIN_WITH_OTP_MODAL: false,
  SHRINK_MODAL: false,
  MRP_UPDATE_MODAL: false,
  REQUEST_SAMPLE_PICKUP_MODAL: false,
  VACCINATION_ENTER_DATA_MODAL: false,
  PO_DELETE_MODAL: false,
  PO_COPY_PREVIOUS_MODAL: false,
  EMR_IMAGE_UPLOAD_MODAL: false,
  CERTIFICATE_DOCUMENT_UPLOAD_MODAL: false,
  CERTIFICATE_DOCUMENT_EDIT_MODAL: false,
  CERTIFICATE_DOCUMENT_VIEW_MODAL: false,
  CERTIFICATE_DOCUMENT_DELETE_MODAL: false,
  TO_SELECTED_ITEM_MODAL: false,
  VACCINATION_OVERDUE_MODAL: false,
  REJECT_REQUEST_MODAL: false,
  SHRINK_IMAGE_MODAL: false,
  INVALID_IMAGE: false,
  SERVICE_IMAGE_VIEW_MODAL: false,
  AT_HOME_ACTION_CONFIRM_MODAL: false,
  INVOICE_ADJUSTMENT_DETAILS_MODAL: false,
  INVOICE_ADJUSTMENT_PREVIEW_MODAL: false,
  TILE_ADD_MODAL: false,
  TILE_VIEW_MODAL: false,
  TILE_DELETE_MODAL: false,
  TILE_EDIT_MODAL: false,
  TILE_SYNC_MODAL: false,
  LAB_REPORT_INTERPRETATION_EMR_MODAL: false,
  LAB_REPORT_INTERPRETATION_REQUISITIONS_MODAL: false,
};

// Define the initial state using that type
const intialRootState: ModalReducerState = {
  ...CustomerProfileModals,
};

export const rootStateSlice = createSlice({
  name: "modals",
  initialState: intialRootState,
  reducers: {
    setModalState: (state, action: PayloadAction<{ key: ModalReducerStateIdKeys; status: boolean }>) => {
      state[action.payload.key as ModalReducerStateIdKeys] = action.payload.status;
    },
  },
});

export const { setModalState } = rootStateSlice.actions;

export default rootStateSlice.reducer;
